<script setup lang="ts">

import {mergeProps, ref} from "vue";
import {useRules} from "vuetify/labs/rules";

const rules = useRules()

const value = defineModel<boolean>()
const label = defineModel<string|null>('label', {
    required: true
})

const initialLabel = label.value

const form = ref<HTMLFormElement>()

const submit = async () => {
    const {valid} = await form.value?.validate()

    if (!valid) {
        return;
    }

    value.value = false;
}

const closeDialog = () => {
    value.value = false;
    label.value = initialLabel;
}
</script>

<template>
    <v-dialog
        v-model="value"
        max-width="500"
        scrim="blue-grey-darken-4"
        opacity="0.5"
        transition="dialog-top-transition"
    >
        <template #activator="{ props: bind }">
            <v-tooltip
                location="start"
                content-class="bg-black border-sm text-tooltip"
                max-width="200"
            >
                <template #activator="{ props: sub }">
                    <v-icon-btn
                        v-bind="mergeProps(bind, sub)"
                        icon="mdi-square-edit-outline"
                        size="small"
                        color="transparent"
                        rounded="lg"
                    />
                </template>
                Edit label
            </v-tooltip>
        </template>
        <template #default>
            <v-card
                class="pa-1"
                rounded="lg"
            >
                <v-form
                    ref="form"
                    @submit.prevent="submit"
                >
                    <v-card-title class="font-weight-bold">
                        Edit label
                        <v-btn
                            :icon="true"
                            color="base"
                            variant="plain"
                            rounded="lg"
                            class="float-end"
                            size="32"
                            @click="value = false"
                        >
                            <v-icon size="20">
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-body-2 px-4 py-0">
                        <p class="mb-5">
                            Please enter a label below.
                        </p>
                        <v-text-field
                            v-model="label"
                            density="compact"
                            type="text"
                            name="label"
                            :rules="[rules.required(), rules.pattern(/^(?!\s*$).+/)]"
                        />
                    </v-card-text>
                    <v-card-actions class="pt-0 mt-5">
                        <v-spacer />
                        <v-btn
                            color="white"
                            variant="flat"
                            border="sm"
                            type="button"
                            @click="closeDialog"
                        >
                            <span class="font-weight-regular">
                                Cancel
                            </span>
                        </v-btn>
                        <v-btn
                            variant="flat"
                            border="sm"
                            type="submit"
                        >
                            <span class="font-weight-regular">
                                Save changes
                            </span>
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </template>
    </v-dialog>
</template>

<style scoped>

</style>
